import { Box, Paper, styled } from '@mui/material';
export const MaintenanceTab = styled(Box)(({ theme }) => ({
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 8,
    padding: 16,
    width: '100%',
}));
export const MaintenanceBlock = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 16,
    width: '100%',
}));
